export const IconChartUp: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3335 5.83337H18.3335V10.8334"
      stroke="#155DFC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3332 5.83337L11.2498 12.9167L7.08317 8.75004L1.6665 14.1667"
      stroke="#155DFC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
